import { makeStyles } from '@mui/styles';
import { drawerWidth } from '../Sidebar';

const useStyles = makeStyles(() => ({
    drawerPaper: {
        width: drawerWidth
    }
}));

export { useStyles };
